export default __webpack_public_path__ + "static/media/laundry1-afterA-768w.5fd5213b.png";